module.exports = __webpack_public_path__ + "static/no-data-okr.05e85439.png";